import React from 'react';
import BusinessObjectFormComponent from '../../components/business-object-form/business-object-form.component';
import { User } from '../../../../../../models/interfaces/User.interface';
import { BusinessObject } from '../../../../../../models/interfaces/BusinessObject.interface';
import { Link, useNavigate, useOutletContext } from 'react-router-dom';
import CategoryTableComponent from '../../../category-context/components/category-table/category-table.component';
import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import BusinessObjectBookingSettingsComponent from '../../components/business-object-booking-settings/business-object-booking-settings.component';
import routeService from '../../../../../../routes/route.service';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  createNewCategoryButton: {
    marginBottom: '20px',
    marginRight: '20px',
  },
});

export default function BusinessObjectDetailComponent() {
  const navigate = useNavigate();

  const { user, businessObject } = useOutletContext<{ user: User; businessObject: BusinessObject }>();

  const isAbleToMassiveUpdate = () => !businessObject?.categories?.length;

  const onBoChangeHandler = async () => {
    window.location.reload();
  };

  const handleCreateCategory = () => {
    navigate(routeService.getAndFillCategoryCreatePath(user?.id, businessObject?.id));
  };

  const classes = useStyles();

  return (
    <>
      {user?.id ? <BusinessObjectFormComponent owner={user} businessObject={businessObject} /> : <></>}

      <BusinessObjectBookingSettingsComponent
        ownerId={user?.id}
        ownerEmail={user?.email}
        businessObject={businessObject}
        onBoChange={onBoChangeHandler}
      />

      <Button
        onClick={handleCreateCategory}
        variant="contained"
        color="primary"
        className={classes.createNewCategoryButton}
        startIcon={<Add />}
      >
        Create new category
      </Button>

      {isAbleToMassiveUpdate() ? (
        <Link to={`${routeService.getAndFillCategoryMassiveCreatePath(user?.id, businessObject?.id)}`}>
          <Button variant="contained" color="primary" className={classes.createNewCategoryButton}>
            Massive create category
          </Button>
        </Link>
      ) : (
        <></>
      )}

      <CategoryTableComponent
        userId={user?.id}
        businessObjectId={businessObject?.id}
        categories={businessObject?.categories}
      />

      <div>
        <Link to={`${routeService.getAndFillUserDetailPath(user?.id)}`}>Back to user detail</Link>
      </div>
    </>
  );
}
